<template>
    <!-- 系统功能维护 -->
    <div>
        系统功能维护
    </div>
</template>

<script>
export default {
    data() {
        return {

        };
    },
    async created() {

    },
    mounted() {

    },
    methods: {

    }
};
</script>

<style scoped lang="less">

</style>
